
import image1 from './assets/image.jpg';
import image2 from './assets/image2.jpg';
import image3 from './assets/image3.jpg';
import image4 from './assets/image4.jpg';
import image5 from './assets/image5.jpg';
import image6 from './assets/image6.jpg';
import image7 from './assets/image7.jpg';
import image8 from './assets/image8.jpg';
import image9 from './assets/image9.jpg'; 
const tvshows = [
    {
        img:image1,
        name:"John wick 1",
        days:"Weekdays",
        time:"8.00pm - 9.00pm"

    },
    {
        img:image2,
        name:"Space Jam",
        days:"Weekdays",
        time:"10.00pm - 11.00pm"

    },
    {
        img:image3,
        name:"John wick 2",
        days:"Weekend",
        time:"12.00pm - 2.00pm"

    },
    {
        img:image4,
        name:"Spider Man",
        days:"Weekdays",
        time:"2.00pm - 4.00pm"

    },
    {
        img:image5,
        name:"Money heist",
        days:"Weekdays",
        time:"4.00pm - 5.00pm"

    },
    {
        img:image6,
        name:"The Cover",
        days:"Weekdays",
        time:"1.00pm - 3.00pm"

    },
    {
        img:image7,
        name:"Money heist",
        days:"Weekdays",
        time:"5.00pm - 6.00pm"

    },
    {
        img:image8,
        name:"Spider Man",
        days:"Weekdays",
        time:"8.00pm - 9.00pm"

    },
    {
        img:image9,
        name:"John wick 2",
        days:"Weekdays",
        time:"5.00pm - 9.00pm"

    },


]




export default tvshows;